import React, { FC } from 'react'
import cx from 'classnames'
import { getInitials } from 'utils/formatting'

interface AvatarOrInitialsProps {
  avatarUrl?: string | null
  name?: string | null
  className?: string
}

const AvatarOrInitials: FC<AvatarOrInitialsProps> = ({ avatarUrl, name, className }) => {
  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={`${name ? `${name}'s` : 'A'} profile pic`}
        className={cx('tw:object-cover', className)}
      />
    )
  }
  if (name) {
    return (
      <div className={cx('tw:flex tw:items-center tw:justify-center tw:pointer-events-none', className)}>
        {getInitials(name)}
      </div>
    )
  }
  return null
}

export default AvatarOrInitials
